module.exports = __webpack_public_path__ + "img/gld_gbt67_2000.prt.a85989a0.jpg";